/*globals $ */

class Slideshow {
  constructor(mainApp) {
    this.mainApp                = mainApp;
    this.$el                    = $('.Slideshow');
    this.$images                = [];
    this.nextDepth              = 1;
    this.currentImg             = 0;
    this.isCompleteIntroduction = false;
    this.duration_intro         = 7000;
    this.duration_default       = 7000;

    this.$el.find('.Slideshow__page').each((i, e) => {
      if(!$(e).hasClass('Slideshow__page--intro')) {
        this.$images.push($(e));
      }
    });

    this.start();
  }

  start() {
    if($('.Slideshow__page--intro').length) {
      $('.Slideshow__page--intro').addClass('Slideshow__page--fadein');
      $('.Slideshow__page--intro').delay(20).animate({'opacity':1}, 1000, 'easeInOutSine');
    } else {
      this.$images[0].addClass('Slideshow__page--fadein');
      this.$images[0].delay(20).animate({'opacity':1}, 1000, 'easeInOutSine');
      this.isCompleteIntroduction = true;
      // this.currentImg = -1;
    }

    if($('.Slideshow').attr('data-duration-default') != undefined) {
      this.duration_default = Number($('.Slideshow').attr('data-duration-default'));
    }

    if($('.Slideshow').attr('data-duration-intro') != undefined) {
      this.duration_intro = Number($('.Slideshow').attr('data-duration-intro'));
    }

    if($('.Slideshow__page--intro').length || ($('.Slideshow__page--intro').length == 0 && this.$images.length > 1 )) {
      setTimeout(() => {
        this.next();
      }, this.duration_intro);
    }
  }

  next() {
    if(!this.isCompleteIntroduction) {
      this.isCompleteIntroduction = true;
      this.$prevImg = $('.Slideshow__page--intro');
    } else {
      this.$prevImg = this.$images[this.currentImg];
      this.currentImg++;
    }
    this.nextDepth++;

    if(this.currentImg >= this.$images.length) {
      this.currentImg = 0;
    }
    for(let i = 0; i < this.$images.length; i++) {
      if(i == this.currentImg) {
        this.$images[i]
          .stop(false)
          .css({
            'opacity': 0,
            'z-index': this.nextDepth
          })
          .addClass('Slideshow__page--fadein')
          .animate({'opacity':1}, 1000, 'easeInOutSine', () => {
            this.$prevImg.removeClass('Slideshow__page--fadein');
          });
      }
    }

    if(this.$images.length > 1) {
      setTimeout(() => {
        this.next();
      }, this.duration_default);
    }
  }
}

export default Slideshow;
